import styled, { css } from "styled-components";

import { IconButton } from "@similarweb/ui-components";

export const StyledCopyButton = styled(IconButton)<{ isLoading?: boolean }>`
    ${({ isLoading }) =>
        isLoading &&
        css`
            & svg {
                width: 19px !important;
                height: 19px !important;
                margin-right: 5px;
            }
        `};
`;
